export default __webpack_public_path__ + "static/shape-f3ce1a9a37c234601efa1c8bb074b53e.svg";